module.exports = __webpack_public_path__ + "img/cogneetiv.1fa7e617.png";